<template>
    <label class="label-select">
        <select name="count"
                v-model="selectedTariff">
            <option
                    v-for="(tariff, key) in subtype.tariffs"
                    :key="key"
                    :value="key"
            >{{tariff.title}}</option>
        </select>
    </label>
</template>

<script>
    export default {
        name: "SubtypeTariffSelect",

        props: {
            subtype: {
                type: Object,
                required: true,
            },
        },

        data(){
            return {
                selectedTariff: 0,
            };
        },

        watch: {
            selectedTariff(selectedTariff){
                this.$emit('input', selectedTariff);
            },
        },

        activated(){
            this.$emit('input', this.selectedTariff);
        },
    }
</script>

<style scoped>

</style>